module.exports = __webpack_public_path__ + "img/zishu.28040978.jpg";